import {createStore} from 'redux'
import reducer from './ReduxReducers'

//Creating the global redux store will all the reducers (states)
const store = createStore(reducer)
export default store



// WEBPACK FOOTER //
// ./src/redux/store.js